const Z = ""

async function _get(url: string) { return (await fetch(`${Z}${url}`)).json() }
async function _post(url: string, body?: unknown) {
  return (await fetch(`${Z}${url}`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })).json()
}
async function _patch(url: string, body?: unknown) {
  return (await fetch(`${Z}${url}`, {
    method: "PATCH", headers: { "Content-Type": "application/json" },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })).json()
}
async function _put(url: string, body?: unknown) {
  return (await fetch(`${Z}${url}`, {
    method: "PUT", headers: { "Content-Type": "application/json" },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })).json()
}
async function _delete(url: string) {
  return (await fetch(`${Z}${url}`, { method: "DELETE" })).json()
}
async function _void_post(url: string, body?: unknown) {
  await fetch(`${Z}${url}`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })
}
async function _void_put(url: string, body?: unknown) {
  await fetch(`${Z}${url}`, {
    method: "PUT", headers: { "Content-Type": "application/json" },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })
}
async function _void_delete(url: string) {
  await fetch(`${Z}${url}`, { method: "DELETE" })
}

// ── Types ──

export interface Settings { [key: string]: string }
export interface SystemStatus { [key: string]: unknown }
export interface LogEntry { time: number; level: string; message: string; ts?: number; msg?: string; src?: string; campaign_id?: string; worker_id?: number; id?: number }
export interface LogHistoryResp { logs: LogEntry[]; oldest_id: number | null; has_more: boolean; run_id: string | null }
export interface WsState { [key: string]: unknown }
export interface RunStats { [key: string]: unknown }
export interface TimelinePoint { ts: number; value: number }
export interface CampaignStats { [key: string]: unknown }
export interface SysInfo { [key: string]: unknown }
export interface HourlyPoint { hour: string; count: number }
export interface HourlyCampaignPoint { hour: string; campaign: string; count: number }
export type SchedType = 'always' | 'daily' | 'weekly'
export interface ScheduleData { type: SchedType; days?: number[]; start_hour?: number; end_hour?: number; duration_minutes?: number; [k: string]: unknown }
export interface RunSummary { id: number; campaign_id: string; started_at: string; ended_at?: string; [k: string]: unknown }
export interface RunLogEntry { ts: number; msg: string; level?: string }
export interface CampaignSummary { id: string; name: string; status: string; [k: string]: unknown }
export interface ProxyCheckResult {
  proxy: string
  proxy_original?: string
  status: string
  verdict?: string
  overall_score?: number
  ip?: string
  ip_version?: number
  city?: string
  country?: string
  isp?: string
  asn?: string
  anonymity?: string
  latency_ms?: number
  error_code?: string
  error_message?: string
  proxy_detected?: boolean
  vpn_detected?: boolean
  hosting?: boolean
  blacklisted?: boolean
  dns_leak?: boolean
  risk_score?: number
  blacklist_sources?: string[]
  proto_confirmed?: string
  elapsed_sec?: number
  scores?: Record<string, number>
  ml_verdict?: { prediction: string; probabilities: Record<string, number> }
  fingerprint?: {
    ja3?: string
    ja4?: string
    ja3_match?: string
    tls_version?: string
    browser_guess?: string
    has_grease?: boolean
    utls_suspected?: boolean
    cipher_count?: number
    extension_count?: number
  }
  tcp?: {
    os_detected?: string
    wscale?: number
    uptime_days?: number
    mss?: number
    mtu?: number
    initial_ttl?: number
    hop_distance?: number
    vpn_tunnel?: boolean
    options_order: string[]
  }
  protocols?: {
    https: boolean
    http: boolean
    ipv4: boolean
    ipv6: boolean
  }
  // Server-side reachability probe: did THIS server (where Chrome runs) manage
  // to reach a target THROUGH the proxy? Catches false-green proxies that pass
  // on pushstat but are unreachable from the client (firewall / IPv6-only
  // endpoint blocked by kill-switch / dead upstream / bad auth).
  local?: {
    checked: boolean
    reachable?: boolean
    stage?: string
    detail?: string
    ms?: number
  }
  // Idea #98 — реальный замер скорости в Мбит/с (по кнопке, хранится тут для рендера).
  speed?: ProxySpeedResult
}
export interface ProxySpeedResult {
  checked: boolean
  ok?: boolean
  mbps?: number
  bytes?: number
  ttfb_ms?: number
  ms?: number
  partial?: boolean
  detail?: string
}
export interface PanelUser { id: number; username: string; role_name: string; access_level: string; products: string; permissions_json?: string; is_global?: number; global_license_key?: string }
export interface TgChat { tg_chat_id: number; tg_first_name?: string; tg_username?: string; notify_start: boolean; notify_stop: boolean; notify_error: boolean }
export interface DomainStatus { domain: string; subdomain: string; parent_domain: string; ssl_status: string; ssl_expiry: string; server_ip: string }
export interface ChangelogEntry { version: string; date: string; title: string; sections: { type: string; items: string[] }[] }
export interface DocsCategory { name: string; entries: DocEntry[] }
export interface DocEntry { slug: string; title: string }
export interface ClientServerInfo {
  id: number; type: 'managed' | 'standalone'; subdomain: string; domain: string;
  ssh_host: string; install_status: string; created_at: number; installed_at: number;
  activation_id: number; is_online: boolean; last_heartbeat: number;
  hostname: string; ip_address: string;
  engine_version: string; chrome_version: string;
  update_status: string; cpu_percent: number; memory_percent: number;
  max_threads: number; cpu_model: string; total_ram_gb: number;
  disk_percent: number; suspended: boolean;
  // Единая биллинг-модель (anchor): индивидуальный срок сервера + статус.
  expires_at?: number; freeze_started_at?: number; days_left?: number;
  billing_status?: 'active' | 'expiring' | 'expired' | 'frozen' | 'suspended' | 'unknown';
}
export interface LicenseKey { id: number; key: string; plan: string; max_threads: number; max_servers: number; created_at: number; expires_at: number; revoked: boolean; suspended: boolean; note: string; products: string; panel_username: string; panel_password: string; billing_start: number; billing_anchor?: number; active_servers?: number; is_valid?: boolean; client_servers_count?: number; client_servers?: ClientServerInfo[]; restrict_bugs?: boolean; restrict_ideas?: boolean; restrict_assistant?: boolean; telegram_contact?: string; [k: string]: unknown }
export interface LicenseActivation { id: number; key_id: number; hardware_id: string; ip_address: string; activated_at: number; last_heartbeat: number; is_active: boolean; hostname: string; os_info: string; custom_domain?: string; [k: string]: unknown }
export interface LicenseStats { total_keys: number; active_keys: number; active_servers: number; [k: string]: unknown }
export interface Deployment { id: number; status: string; [k: string]: unknown }
export interface DeploymentTarget { [k: string]: unknown }
export interface ServerInfo { activation_id: number; [k: string]: unknown }
export interface ReleaseInfo { [k: string]: unknown }
export interface ConfigSnapshot { id: string; name: string; created_at: string; [k: string]: unknown }
export interface FailGroupItem {
  site: string
  key: string
  proxy: string
  captcha: string
  worker: string
  ts: number
  // Profiler-only diagnostics (где упала итерация): step index, node id and
  // cube type of the failing scenario action. Absent for booster items.
  step?: string
  node?: string
  type?: string
}
export interface FailGroup { count: number; messages: string[]; items: FailGroupItem[]; [k: string]: unknown }

// ── Auth ──

export interface PublicServer { subdomain: string; domain: string; url: string; server_name?: string; server_icon?: string }
/** Sibling servers of this panel's license — works WITHOUT a session
 *  (used by the login page). Returns naming/url fields only, no secrets. */
export async function fetchPublicServers(): Promise<PublicServer[]> {
  try {
    const r = await fetch(`${Z}/api/public-servers`)
    if (!r.ok) return []
    const d = await r.json()
    return Array.isArray(d?.servers) ? d.servers : []
  } catch { return [] }
}
export async function login(username: string, password: string) { return _post("/api/login", { username, password }) }
export async function logout() { await fetch(`${Z}/api/logout`, { method: "POST" }) }

// DEV-only Chrome engine (147/152) selector — inert on client panels (backend gates on BB_INTERNAL + 152 binary presence).
export async function getDevChromeEngine(): Promise<{ available: boolean; engine: string; path_152?: string }> { return _get("/api/dev/chrome-engine") }
export async function setDevChromeEngine(engine: "147" | "152") { return _post("/api/dev/chrome-engine", { engine }) }
export async function getMe() { const r = await fetch(`${Z}/api/me`); return r.ok ? r.json() : { error: "unauthorized" } }

// ── Panel settings ──

export async function getPanelSettings() { return _get("/api/panel-settings") }
export async function savePanelSettings(s: Record<string, string>) { return _post("/api/panel-settings", s) }
export async function changePassword(old_password: string, new_password: string) { return _post("/api/change-password", { old_password, new_password }) }

// ── Proxy presets (Idea #14) ──

export interface ProxyPreset {
  id: number
  name: string
  type: string
  format: string
  mind_link: string
  proxy_list: string
  ipport: string
  shuffle: boolean
  created_at: number
  updated_at: number
}

export async function listProxyPresets(): Promise<ProxyPreset[]> {
  const r = await _get("/api/proxy-presets") as { presets?: ProxyPreset[] }
  return r.presets ?? []
}
export async function createProxyPreset(preset: Partial<ProxyPreset>) { return _post("/api/proxy-presets", preset) as Promise<{ ok: boolean; id?: number; error?: string }> }
export async function updateProxyPreset(id: number, preset: Partial<ProxyPreset>) { return _put(`/api/proxy-presets/${id}`, preset) as Promise<{ ok: boolean; error?: string }> }
export async function deleteProxyPreset(id: number) { return _delete(`/api/proxy-presets/${id}`) as Promise<{ ok: boolean; error?: string }> }

// ── Users ──

export async function listUsers(): Promise<PanelUser[]> { const r = await fetch(`${Z}/api/users`); return r.ok ? r.json() : [] }
export async function createUser(data: Partial<PanelUser> & { password: string; permissions?: string[] }) { return _post("/api/users", data) }
export async function updateUser(id: number, data: Record<string, any>) { return _put(`/api/users/${id}`, data) }
export async function deleteUser(id: number) { return _delete(`/api/users/${id}`) }

// ── Server ──

export async function rebootServer() { return _post("/api/reboot") }
export async function healthCheck(): Promise<boolean> { try { return (await fetch(`${Z}/api/health`, { signal: AbortSignal.timeout(3000) })).ok } catch { return false } }

// ── Profiler config ──

export async function getProfilerConfig() { return _get("/api/config") }
export async function saveProfilerConfig(data: unknown) { await _void_post("/api/config", data) }
export async function startProfiler() { return _post("/api/start") }
export async function stopProfiler() { await _void_post("/api/stop") }

// ── Profiler campaigns (multi-preset warming) ──

export async function getProfilerCampaigns() { return _get("/api/profiler/campaigns") }
export async function createProfilerCampaign(name: string) {
  return _post("/api/profiler/campaigns", { name })
}
export async function getProfilerCampaign(cid: string) {
  return _get(`/api/profiler/campaigns/${cid}`)
}
export async function updateProfilerCampaign(cid: string, body: {
  name?: string
  settings?: any
  archived?: boolean
  starred?: boolean
  comment?: string
  color?: string
  sched_enabled?: boolean
  schedule?: any
  [k: string]: unknown
}) {
  await _void_put(`/api/profiler/campaigns/${cid}`, body)
}
export async function deleteProfilerCampaign(cid: string) {
  await _void_delete(`/api/profiler/campaigns/${cid}`)
}
export async function startProfilerCampaign(cid: string) {
  return _post(`/api/profiler/campaigns/${cid}/start`)
}
export async function stopProfilerCampaign(cid: string) {
  await _void_post(`/api/profiler/campaigns/${cid}/stop`)
}
export async function copyProfilerCampaign(cid: string) {
  return _post(`/api/profiler/campaigns/${cid}/copy`)
}
export async function toggleStarProfilerCampaign(cid: string) {
  return _post(`/api/profiler/campaigns/${cid}/star`)
}
export async function reorderProfilerCampaigns(ids: string[]) {
  await _void_post(`/api/profiler/campaigns/reorder`, { ids })
}

// ── Booster config ──

export async function getBoosterConfig() { return _get("/api/booster/config") }
export async function saveBoosterConfig(data: unknown) { await _void_post("/api/booster/config", data) }

// ── Campaigns ──

export async function getCampaigns() { return _get("/api/booster/campaigns") }
export async function createCampaign(name: string, opts?: Record<string, unknown>) { return _post("/api/booster/campaigns", { name, ...opts }) }
export async function getCampaign(id: string) { return _get(`/api/booster/campaigns/${id}`) }
export async function updateCampaign(id: string, data: Record<string, unknown>) { await _void_put(`/api/booster/campaigns/${id}`, data) }
export async function deleteCampaign(id: string) { await _void_delete(`/api/booster/campaigns/${id}`) }
export async function startCampaign(id: string) { return _post(`/api/booster/campaigns/${id}/start`) }
export async function stopCampaign(id: string) { await _void_post(`/api/booster/campaigns/${id}/stop`) }
export async function pauseCampaign(id: string) { return _post(`/api/booster/campaigns/${id}/pause`) }
export async function resumeCampaign(id: string) { return _post(`/api/booster/campaigns/${id}/resume`) }
export async function uploadCampaignFolder(id: string, files: File[]) {
  const fd = new FormData()
  for (const f of files) fd.append("files", f)
  return (await fetch(`${Z}/api/booster/campaigns/${id}/upload-folder`, { method: "POST", body: fd })).json()
}
export async function reorderCampaigns(ids: string[]) { await _void_post("/api/booster/campaigns/reorder", { ids }) }
export async function getCampaignFiles(id: string) { return _get(`/api/booster/campaigns/${id}/files`) }
export async function getCampaignFilesContent(id: string) { return _get(`/api/booster/campaigns/${id}/files/content`) }
export async function saveCampaignFilesContent(id: string, data: Record<string, string>) { return _put(`/api/booster/campaigns/${id}/files/content`, data) }
export async function checkKeywordsSuggest(
  keywords: string[],
  lr?: string,
  init?: { signal?: AbortSignal },
): Promise<{ results: Record<string, number> }> {
  // Bug #29: support AbortSignal so caller can cancel batch / set
  // per-request timeout. Without this the panel UI would hang
  // forever if backend `_check_one` got stuck.
  const r = await fetch(`${Z}/api/booster/suggest-check`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ keywords, lr: lr || '213' }),
    signal: init?.signal,
  })
  return r.json()
}
export async function toggleStarCampaign(id: string) { return _post(`/api/booster/campaigns/${id}/star`) }
export async function copyCampaign(id: string) { return _post(`/api/booster/campaigns/${id}/copy`) }
export async function exportCampaignConfig(id: string) {
  const r = await fetch(`${Z}/api/booster/campaigns/${id}/export`)
  const blob = await r.blob()
  const m = (r.headers.get('content-disposition') || '').match(/filename="?([^"]+)"?/)
  const name = m ? m[1] : 'project_settings.json'
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a'); a.href = url; a.download = name; a.click(); URL.revokeObjectURL(url)
}
export async function importCampaignConfig(id: string, data: unknown) { return _post(`/api/booster/campaigns/${id}/import`, data) }

// ── Stats & logs ──

export async function getStats() { return _get("/api/stats") }
export async function getRuns(limit = 50, offset = 0, campaignId?: string): Promise<RunSummary[]> {
  let url = `${Z}/api/runs?limit=${limit}&offset=${offset}`
  if (campaignId) url += `&campaign_id=${encodeURIComponent(campaignId)}`
  return (await fetch(url)).json()
}
export async function getRunLogs(runId: number, limit = 2000, offset = 0): Promise<RunLogEntry[]> {
  return (await fetch(`${Z}/api/runs/${runId}/logs?limit=${limit}&offset=${offset}`)).json()
}

// ── Idea #85: project change history (audit log) ──
export interface AuditEntry {
  id: number
  ts: number
  actor: string
  action: string
  action_label: string
  field: string
  field_label: string
  old_value: string | null
  new_value: string | null
  note: string
}
export interface AuditResp { items: AuditEntry[]; total: number }
export async function getProjectAudit(
  mode: 'booster' | 'profiler',
  cid: string,
  limit = 200,
  offset = 0,
): Promise<AuditResp> {
  try {
    const r = await fetch(`${Z}/api/${mode}/campaigns/${encodeURIComponent(cid)}/audit?limit=${limit}&offset=${offset}`)
    if (!r.ok) return { items: [], total: 0 }
    return await r.json()
  } catch {
    return { items: [], total: 0 }
  }
}

// ── Idea #96: суточная история проекта (клики vs позиции по дням) ──
export interface DailyHistoryPoint {
  date: string          // 'YYYY-MM-DD'
  ok: number
  fail: number
  captcha: number
  avg_position: number  // средневзвешенная по кликам; 0 = нет данных
}
export interface DailyHistoryResp { items: DailyHistoryPoint[]; days: number }
export async function getDailyHistory(
  mode: 'booster' | 'profiler',
  cid: string,
  days = 30,
): Promise<DailyHistoryResp> {
  try {
    const r = await fetch(`${Z}/api/${mode}/campaigns/${encodeURIComponent(cid)}/daily-history?days=${days}`)
    if (!r.ok) return { items: [], days }
    return await r.json()
  } catch {
    return { items: [], days }
  }
}

// ── Live log history (scroll-up "load older") ──
// Pulls progressively older lines for a campaign's current/last run from
// logs.db via cursor pagination. `beforeId` undefined → newest tail.
export async function fetchLogHistory(
  mode: "booster" | "profiler",
  cid: string,
  beforeId?: number,
  limit = 500,
): Promise<LogHistoryResp> {
  const qs = new URLSearchParams({ limit: String(limit) })
  if (beforeId && beforeId > 0) qs.set("before_id", String(beforeId))
  try {
    const r = await fetch(`${Z}/api/${mode}/campaigns/${encodeURIComponent(cid)}/logs/history?${qs}`)
    if (!r.ok) return { logs: [], oldest_id: null, has_more: false, run_id: null }
    return await r.json()
  } catch {
    return { logs: [], oldest_id: null, has_more: false, run_id: null }
  }
}

// ── WebSocket ──

export function connectWs(
  onLogs: (entries: LogEntry[], isInitial: boolean) => void,
  onStatus?: (status: string) => void,
  onState?: (state: WsState) => void,
) {
  let ws: WebSocket | null = null
  let stopped = false
  let delay = 1000
  let isInitial = false
  function connect() {
    if (stopped) return
    onStatus?.("connecting")
    const proto = location.protocol === "https:" ? "wss" : "ws"
    ws = new WebSocket(`${proto}://${location.host}/ws/logs`)
    ws.onopen = () => { delay = 1000; isInitial = true; onStatus?.("connected") }
    ws.onmessage = (ev) => {
      try {
        const m = JSON.parse(ev.data)
        if (Array.isArray(m)) { onLogs(m, isInitial); isInitial = false }
        else if (m.t === "logs") { onLogs(m.d, isInitial); isInitial = false }
        else if (m.t === "state") { onState?.(m.d) }
      } catch { /* ignore parse errors */ }
    }
    ws.onclose = () => { onStatus?.("disconnected"); if (!stopped) { setTimeout(connect, delay); delay = Math.min(delay * 1.5, 10000) } }
    ws.onerror = () => { ws?.close() }
  }
  connect()
  return { close: () => { stopped = true; ws?.close() } }
}

// ── Screenshots & VNC ──

export function screenshotUrl(workerId: number | string) { return `${Z}/api/screenshot/${workerId}?t=${Date.now()}` }
// VNC endpoints take an Xvfb display number (e.g. 149), not a worker_id —
// see panel/server.py docstring on `vnc_start`. Worker.display strings
// like ":149" are parsed at the call site (ResultsView).
export async function startVnc(displayNum: number | string) {
  try { const r = await fetch(`${Z}/api/vnc/start/${displayNum}`, { method: "POST" }); return r.ok ? r.json() : { error: await r.text() } }
  catch (e) { return { error: String(e) } }
}
export async function stopVnc(displayNum: number | string) {
  try { await fetch(`${Z}/api/vnc/stop/${displayNum}`, { method: "POST" }) } catch { /* ignore */ }
}

// ── Scenario debug session (BAS-style record/debug mode; super-admin/dev only) ──
// Frozen contract — the BE worker implements the matching server side.
export interface DebugVncInfo { vnc_port: number; vnc_pw: string; interactive: boolean; screen_w: number; screen_h: number }
export interface DebugSessionInfo { sid: string; display_num: number; vnc: DebugVncInfo; error?: string }
export type DebugSettingsSource = { kind: "synthetic" } | { kind: "campaign"; cid: string }

export async function createDebugSession(): Promise<DebugSessionInfo> {
  return _post("/api/admin/debug-session")
}
export async function loadDebugSession(sid: string, script: unknown, settings_source: DebugSettingsSource = { kind: "synthetic" }) {
  return _post(`/api/admin/debug-session/${sid}/load`, { script, settings_source })
}
export async function runDebugSession(sid: string, mode: "run" | "step" = "run", start_node_id: string | null = null) {
  // start_node_id — id кубика «запустить отсюда» (BAS-маркер старта); null = с начала
  // (бэкенд тогда выполнит и OnApplicationStart). Поле опционально на стороне БЭ.
  return _post(`/api/admin/debug-session/${sid}/run`, { mode, start_node_id })
}
export async function pauseDebugSession(sid: string) { return _post(`/api/admin/debug-session/${sid}/pause`) }
export async function resumeDebugSession(sid: string) { return _post(`/api/admin/debug-session/${sid}/resume`) }
export async function stepDebugSession(sid: string) { return _post(`/api/admin/debug-session/${sid}/step`) }
export async function stopDebugSession(sid: string) { return _post(`/api/admin/debug-session/${sid}/stop`) }
export async function setDebugBreakpoints(sid: string, set: string[] = [], clear: string[] = []) {
  return _post(`/api/admin/debug-session/${sid}/breakpoints`, { set, clear })
}
export async function setDebugManual(sid: string, enabled: boolean) {
  return _post(`/api/admin/debug-session/${sid}/manual`, { enabled })
}
export async function deleteDebugSession(sid: string) {
  // Tolerant teardown — never throw on unmount/cleanup.
  try { await fetch(`${Z}/api/admin/debug-session/${sid}`, { method: "DELETE" }) } catch { /* ignore */ }
}

// ── Scenario deploy / versions / rollback (super-admin/dev only) ──
// Frozen panel-proxy contract — the BE worker implements the matching server side.
// global-scenario (GET/PUT) остаётся для локального черновика; deploy публикует
// версию (immutable, с content_hash и идемпотентностью), versions/rollback —
// история и откат опубликованных версий.
export interface ScenarioVersion {
  version: number
  content_hash: string
  is_active: boolean
  note: string
  published_at: number
  published_by: string
  content_bytes: number
}
export interface ScenarioDeployResult {
  ok: boolean
  version: number
  content_hash: string
  idempotent: boolean
  error?: string
}
export interface ScenarioRollbackResult {
  ok: boolean
  version: number
  content_hash?: string
  error?: string
  [k: string]: unknown
}

export async function deployScenario(content: unknown, note?: string): Promise<ScenarioDeployResult> {
  return _post("/api/admin/scenario/deploy", { product: "profiler", content, ...(note ? { note } : {}) })
}
export async function getScenarioVersions(): Promise<ScenarioVersion[]> {
  const r = await _get("/api/admin/scenario/versions?product=profiler") as ScenarioVersion[] | { scenarios?: ScenarioVersion[]; versions?: ScenarioVersion[] }
  return Array.isArray(r) ? r : (r.scenarios ?? r.versions ?? [])
}
export async function rollbackScenario(version: number): Promise<ScenarioRollbackResult> {
  return _post("/api/admin/scenario/rollback", { product: "profiler", version })
}

// Источник истины глобального сценария: опубликованная версия vs дефолт из кода.
export interface GlobalScenarioStatus {
  published: boolean
  version: number | null
  source: "published" | "code-default"
  updated_at: number | null
}
// Отказоустойчиво: если эндпоинт ещё не задеплоен / 404 / сетевая ошибка —
// возвращаем null (вызывающий просто не показывает бейдж). Без исключений в UI.
export async function getGlobalScenarioStatus(): Promise<GlobalScenarioStatus | null> {
  try {
    const r = await fetch(`${Z}/api/admin/global-scenario/status`, { signal: AbortSignal.timeout(4000) })
    if (!r.ok) return null
    const d = await r.json()
    if (!d || typeof d !== "object") return null
    if (d.source !== "published" && d.source !== "code-default") return null
    return d as GlobalScenarioStatus
  } catch { return null }
}

// ── Changelog ──

export async function getChangelog(): Promise<ChangelogEntry[]> { return _get("/api/changelog") }

// ── Domain & SSL ──

export async function getDomainStatus(): Promise<DomainStatus> { return _get("/api/domain/status") }
export async function setupDomain(subdomain: string) { return _post("/api/domain/setup", { subdomain }) }
export async function removeDomain() { return _post("/api/domain/remove") }

// ── Telegram ──

export async function getTgStatus() { return _get("/api/telegram/status") }
export async function setTgToken(token: string) { return _post("/api/telegram/set-token", { token }) }
export async function removeTgChat(chatId: number) { return _post("/api/telegram/remove-chat", { chat_id: chatId }) }
export async function updateTgPrefs(chatId: number, prefs: Record<string, boolean>) { return _post("/api/telegram/update-prefs", { chat_id: chatId, prefs }) }
export async function testTgNotification(chatId: number) { return _post("/api/telegram/test", { chat_id: chatId }) }

// ── Monitor Hub (централизованный @CreepMonitorBot) ──
export async function getMonitorStatus(): Promise<{ available: boolean; bound: boolean; chats: number }> { return _get("/api/monitor/status") }
export async function createMonitorLink(): Promise<{ ok: boolean; deep_link?: string; ttl_sec?: number; error?: string }> { return _post("/api/monitor/link", {}) }
export async function testMonitorAlert(): Promise<{ ok: boolean; error?: string }> { return _post("/api/monitor/test", {}) }
export interface MonitorChat {
  chat_id: string; username?: string; first_name?: string
  muted?: boolean; muted_until?: number
  quiet_start?: number; quiet_end?: number; min_severity?: string
}
export async function getMonitorChats(): Promise<{ chats: MonitorChat[] }> { return _get("/api/monitor/chats") }
export async function setMonitorChatPrefs(payload: Record<string, unknown>): Promise<{ ok: boolean }> { return _post("/api/monitor/chat-prefs", payload) }

// ── Proxy checker ──

export async function checkProxies(proxies: string[], proto?: string): Promise<ProxyCheckResult[]> {
  const r = await fetch(`${Z}/api/tools/proxy-check`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ proxies, proto: proto || "auto" }),
  })
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: "request failed" }))
    throw new Error(err.error || "request failed")
  }
  return (await r.json()).results ?? []
}

// Idea #98 — замер скорости одного прокси в Мбит/с (Cloudflare speed CDN через прокси).
export async function measureProxySpeed(proxy: string, proto?: string): Promise<ProxySpeedResult> {
  const r = await fetch(`${Z}/api/tools/proxy-speed`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ proxy, proto: proto || "auto" }),
  })
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: "request failed" }))
    throw new Error(err.error || "request failed")
  }
  return (await r.json()).result ?? { checked: false }
}

// ── Full-chain check: Server → VPN → proxy → Yandex (idea #84) ──

export type ChainMode = 'direct' | 'vpn' | 'proxy' | 'vpn_proxy'

export interface ChainStage {
  key: string
  label: string
  status: 'ok' | 'warn' | 'fail' | 'skip'
  detail: string
  ms?: number | null
  loss_pct?: number | null
  http_code?: number | null
  captcha?: boolean
}
export interface ChainGeo {
  ip?: string | null
  country?: string | null
  country_code?: string | null
  region_name?: string | null
  city?: string | null
  isp?: string | null
  org?: string | null
  as?: string | null
  reverse?: string | null
  timezone?: string | null
  mobile?: boolean
  proxy?: boolean
  hosting?: boolean
}
export interface ChainModeResult {
  mode: ChainMode
  label: string
  available: boolean
  skipped_reason?: string | null
  stages: ChainStage[]
  outer_ip?: string | null
  geo?: ChainGeo | null
  verdict: 'ok' | 'warn' | 'fail'
  error?: string
  elapsed_ms?: number
}
export interface ChainCheckResult {
  vpn: { active: boolean; name?: string | null; endpoint_host?: string | null }
  sockmark_so_found: boolean
  proxy_provided: boolean
  proxy_masked?: string | null
  modes: ChainModeResult[]
}

export async function chainCheck(
  proxy: string, modes: ChainMode[], proto?: string,
): Promise<ChainCheckResult> {
  const r = await fetch(`${Z}/api/tools/chain-check`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ proxy, modes, proto: proto || "auto" }),
  })
  if (!r.ok) {
    const err = await r.json().catch(() => ({ error: "request failed" }))
    throw new Error(err.error || "request failed")
  }
  return await r.json()
}

// ── Docs ──

export async function getDocsIndex(): Promise<DocsCategory[]> { return _get("/api/docs/index") }
export async function getDoc(slug: string): Promise<{ content: string }> { return _get(`/api/docs/${encodeURIComponent(slug)}`) }

// ── Updates ──

export async function triggerUpdate() { return _post("/api/trigger-update") }
export async function checkForUpdate(): Promise<{ current_version: string; available_update: any }> { return _post("/api/update/check") }

// ── License self-info ─────────────────────────────────────────
export interface LicenseServer {
  subdomain: string
  domain: string
  ssh_host: string
  install_status: string
  max_threads: number
  installed_at: number
  server_name: string
}
export interface LicenseInfo {
  key?: string
  plan?: string
  panel_username?: string
  products?: string
  max_threads?: number
  max_servers?: number
  expires_at?: number
  days_left?: number
  billing_start?: number
  created_at?: number
  suspended?: boolean
  revoked?: boolean
  note?: string
  is_valid?: boolean
  servers?: LicenseServer[]
  servers_count?: number
  identifiers?: {
    galaxy?: string[]
    space?: string[]
    pusher_two?: string[]
    pusher_one?: string[]
  }
  error?: string
}

export async function getLicenseInfo(): Promise<LicenseInfo> {
  return _get('/api/license-info')
}
export async function installUpdate(): Promise<{ ok?: boolean; error?: string; version?: string; restarting?: boolean }> { return _post("/api/update/install") }

// ── VPN ──

export async function vpnInstall(data: { vpn_host: string; vpn_user: string; vpn_pass: string }) { return _post("/api/vpn/install", data) }
export async function vpnStatus(): Promise<{ installed: boolean; connected: boolean; vpn_ip?: string; endpoint?: string; vpn_host?: string; last_handshake?: string }> { return _get("/api/vpn/status") }
export async function vpnReconnect() { return _post("/api/vpn/reconnect") }
export async function vpnDisable() { return _post("/api/vpn/disable") }
export async function vpnRemove() { return _post("/api/vpn/remove") }
export async function vpnSetFlag(name: string, value: any) { return _post("/api/vpn/flags", { name, value }) }

// ── Ideas (client) ─────────────────────────────────────────────────
export type IdeaStatus = "voting" | "in_progress" | "done" | "rejected"
export type Idea = {
  id: number
  title: string
  description: string
  category: string
  status: IdeaStatus
  pinned: boolean
  hidden?: boolean
  author: string
  author_label: string
  created_at: number
  updated_at: number
  votes_up: number
  votes_down: number
  score: number
  my_vote: number
  comments_count: number
  screenshots?: string[]     // filenames — prepend with /api/ideas/uploads/ to load
  is_mine?: boolean          // Idea #79: this idea was created by the current requester
}
export type IdeaComment = {
  id: number
  text: string
  author: string
  author_label: string
  is_admin: boolean
  is_mine?: boolean
  deleted?: boolean
  created_at: number
  screenshots?: string[]
}

export function ideaScreenshotUrl(name: string): string {
  return `/api/ideas/uploads/${name}`
}

export async function ideasUploadScreenshot(file: File): Promise<{ ok?: boolean; filename?: string; error?: string; size?: number }> {
  const form = new FormData()
  form.append("file", file)
  try {
    const r = await fetch("/api/ideas/uploads", { method: "POST", body: form, credentials: "include" })
    const j = await r.json().catch(() => ({}))
    if (!r.ok) return { error: j?.error || `HTTP ${r.status}` }
    return j
  } catch (e: any) {
    return { error: e?.message || "network error" }
  }
}

export async function ideasMeta(): Promise<{ statuses: string[]; categories: string[] }> { return _get("/api/ideas/meta") }
export async function ideasList(params?: { status?: string; category?: string; sort?: string; limit?: number }): Promise<{ ideas: Idea[] }> {
  const q = new URLSearchParams()
  if (params?.status) q.set("status", params.status)
  if (params?.category) q.set("category", params.category)
  if (params?.sort) q.set("sort", params.sort)
  if (params?.limit) q.set("limit", String(params.limit))
  const s = q.toString()
  return _get(`/api/ideas${s ? "?" + s : ""}`)
}
export async function ideasGet(id: number): Promise<{ idea: Idea; comments: IdeaComment[] }> { return _get(`/api/ideas/${id}`) }
export async function ideasCreate(data: { title: string; description?: string; category?: string; author_label?: string; screenshots?: string[] }) { return _post("/api/ideas", data) }
export async function ideasVote(id: number, value: -1 | 0 | 1) { return _post(`/api/ideas/${id}/vote`, { value }) }
export async function ideasComment(id: number, text: string, author_label?: string, screenshots?: string[]) { return _post(`/api/ideas/${id}/comments`, { text, author_label, screenshots }) }
export async function ideasDeleteOwn(id: number) { return _delete(`/api/ideas/${id}`) }
export async function ideasDeleteOwnComment(id: number) { return _delete(`/api/ideas/comments/${id}`) }

// ── Ideas (admin only) ─────────────────────────────────────────────
export async function ideasAdminList(params?: { status?: string; category?: string; hidden?: boolean; sort?: string; limit?: number }) {
  const q = new URLSearchParams()
  if (params?.status) q.set("status", params.status)
  if (params?.category) q.set("category", params.category)
  if (params?.hidden !== undefined) q.set("hidden", String(params.hidden))
  if (params?.sort) q.set("sort", params.sort)
  if (params?.limit) q.set("limit", String(params.limit))
  const s = q.toString()
  return _get(`/api/ideas-admin/ideas${s ? "?" + s : ""}`)
}
export async function ideasAdminGet(id: number) { return _get(`/api/ideas-admin/ideas/${id}`) }
export async function ideasAdminPatch(id: number, data: Partial<Idea>) { return _patch(`/api/ideas-admin/ideas/${id}`, data) }
export async function ideasAdminDelete(id: number) { return _delete(`/api/ideas-admin/ideas/${id}`) }
export async function ideasAdminReply(id: number, text: string, screenshots?: string[]) { return _post(`/api/ideas-admin/ideas/${id}/reply`, { text, screenshots }) }
export async function ideasAdminDeleteComment(id: number) { return _delete(`/api/ideas-admin/comments/${id}`) }
export async function ideasAdminStats() { return _get(`/api/ideas-admin/stats`) }

// ── Bugs (client) ──────────────────────────────────────────────────
export type BugStatus = "new" | "confirmed" | "in_progress" | "fixed" | "resolved" | "wont_fix" | "duplicate"
export type BugSeverity = "low" | "medium" | "high" | "critical"
export type Bug = {
  id: number
  title: string
  description: string
  steps_to_reproduce: string
  expected: string
  actual: string
  severity: BugSeverity
  affects_version: string
  browser_info: string
  category: string
  status: BugStatus
  pinned: boolean
  hidden?: boolean
  author: string
  author_label: string
  created_at: number
  updated_at: number
  votes_up: number
  votes_down: number
  score: number
  my_vote: number
  comments_count: number
  screenshots?: string[]
  client?: { panel_username?: string; note?: string; hostname?: string; plan?: string }
  is_mine?: boolean   // Idea #35: this bug was created by the current requester
}
export type BugComment = {
  id: number
  text: string
  author: string
  author_label: string
  is_admin: boolean
  is_mine?: boolean
  deleted?: boolean
  created_at: number
  screenshots?: string[]
}

// Uploads общие с Ideas — используем тот же эндпоинт и ту же URL-схему,
// файлы хранятся в одной директории на license-сервере.
export async function bugsUploadScreenshot(file: File) { return ideasUploadScreenshot(file) }
export function bugScreenshotUrl(name: string): string { return ideaScreenshotUrl(name) }

export async function bugsMeta(): Promise<{ statuses: string[]; severities: string[]; categories: string[] }> { return _get("/api/bugs/meta") }
export async function bugsList(params?: { status?: string; statuses?: string; category?: string; severity?: string; sort?: string; limit?: number }): Promise<{ bugs: Bug[] }> {
  const q = new URLSearchParams()
  if (params?.status) q.set("status", params.status)
  if (params?.statuses) q.set("statuses", params.statuses)
  if (params?.category) q.set("category", params.category)
  if (params?.severity) q.set("severity", params.severity)
  if (params?.sort) q.set("sort", params.sort)
  if (params?.limit) q.set("limit", String(params.limit))
  const s = q.toString()
  return _get(`/api/bugs${s ? "?" + s : ""}`)
}
export async function bugsGet(id: number): Promise<{ bug: Bug; comments: BugComment[] }> { return _get(`/api/bugs/${id}`) }
export async function bugsCreate(data: {
  title: string; description?: string; steps_to_reproduce?: string; expected?: string;
  actual?: string; severity?: string; affects_version?: string; browser_info?: string;
  category?: string; author_label?: string; screenshots?: string[]
}) { return _post("/api/bugs", data) }
export async function bugsVote(id: number, value: 0 | 1) { return _post(`/api/bugs/${id}/vote`, { value }) }
export async function bugsComment(id: number, text: string, author_label?: string, screenshots?: string[]) { return _post(`/api/bugs/${id}/comments`, { text, author_label, screenshots }) }
export async function bugsDeleteOwn(id: number) { return _delete(`/api/bugs/${id}`) }
export async function bugsDeleteOwnComment(id: number) { return _delete(`/api/bugs/comments/${id}`) }
// Idea #35: edit own bug + reopen
export async function bugsUpdateOwn(id: number, data: Partial<{
  title: string; description: string; steps_to_reproduce: string; expected: string;
  actual: string; severity: string; affects_version: string; browser_info: string;
  category: string; screenshots: string[]
}>) { await _void_put(`/api/bugs/${id}`, data) }
export async function bugsReopen(id: number, text: string) {
  return _post(`/api/bugs/${id}/reopen`, { text })
}

// ── Bugs (admin only) ──────────────────────────────────────────────
export async function bugsAdminList(params?: { status?: string; category?: string; severity?: string; hidden?: boolean; sort?: string; limit?: number }) {
  const q = new URLSearchParams()
  if (params?.status) q.set("status", params.status)
  if (params?.category) q.set("category", params.category)
  if (params?.severity) q.set("severity", params.severity)
  if (params?.hidden !== undefined) q.set("hidden", String(params.hidden))
  if (params?.sort) q.set("sort", params.sort)
  if (params?.limit) q.set("limit", String(params.limit))
  const s = q.toString()
  return _get(`/api/bugs-admin/bugs${s ? "?" + s : ""}`)
}
export async function bugsAdminGet(id: number) { return _get(`/api/bugs-admin/bugs/${id}`) }
export async function bugsAdminPatch(id: number, data: Partial<Bug>) { return _patch(`/api/bugs-admin/bugs/${id}`, data) }
export async function bugsAdminDelete(id: number) { return _delete(`/api/bugs-admin/bugs/${id}`) }
export async function bugsAdminReply(id: number, text: string, screenshots?: string[]) { return _post(`/api/bugs-admin/bugs/${id}/reply`, { text, screenshots }) }
export async function bugsAdminDeleteComment(id: number) { return _delete(`/api/bugs-admin/comments/${id}`) }
export async function bugsAdminStats() { return _get(`/api/bugs-admin/stats`) }

export async function vpnConnectKey(data: { config: string }) { return _post("/api/vpn/connect-key", data) }
export async function vpnInstallLog(): Promise<{ log: string[]; installing: boolean }> { return _get("/api/vpn/install-log") }

// ── License admin ──

export async function getLicenseStats(): Promise<LicenseStats> { return _get("/api/admin/license/stats") }
export async function getLicenseKeys(): Promise<LicenseKey[]> { return _get("/api/admin/license/keys") }
export async function createLicenseKey(data: Record<string, unknown>) { return _post("/api/admin/license/keys", data) }
export async function revokeLicenseKey(key: string) { return _post("/api/admin/license/keys/revoke", { key }) }
export async function extendLicenseKey(
  key: string,
  opts: number | { days?: number; expires_at?: number; billing_start?: number },
) {
  const body = typeof opts === 'number' ? { key, days: opts } : { key, ...opts }
  return _post("/api/admin/license/keys/extend", body)
}
export async function getLicenseActivations(key: string): Promise<LicenseActivation[]> { return _get(`/api/admin/license/keys/${encodeURIComponent(key)}/activations`) }

// ── Client servers ──

export async function getClientServers(key: string): Promise<ClientServerInfo[]> { return _get(`/api/admin/license/keys/${encodeURIComponent(key)}/servers`) }
export async function addClientServer(key: string, data: { ssh_host: string; ssh_user: string; ssh_password: string; subdomain?: string; max_threads?: number; product?: string }) { return _post(`/api/admin/license/keys/${encodeURIComponent(key)}/servers`, data) }

// ── Work servers pool (профайлер, внутренний) ──
export interface WorkPool { id: number; key: string; panel_username: string; is_work_pool: boolean; servers: ClientServerInfo[]; [k: string]: unknown }
export async function getWorkPool(): Promise<WorkPool> { return _get('/api/admin/work-servers/pool') }
export async function updateClientServer(serverId: number, data: { max_threads?: number }) { return _patch(`/api/admin/license/client-servers/${serverId}`, data) }
export async function getInstallLog(serverId: number): Promise<{ server_id: number; status: string; log: string }> { return _get(`/api/admin/license/client-servers/${serverId}/log`) }
export async function reinstallServer(serverId: number) { return _post(`/api/admin/license/client-servers/${serverId}/reinstall`) }
export async function adoptServer(data: { activation_id: number; ssh_host: string; ssh_user: string; ssh_password: string; subdomain?: string }) { return _post('/api/admin/license/client-servers/adopt', data) }

// ── Deployments ──

export async function getDeployments(): Promise<Deployment[]> { return _get("/api/admin/license/deployments") }
export async function getDeployment(id: number): Promise<Deployment> { return _get(`/api/admin/license/deployments/${id}`) }
export async function createDeployment(data: Record<string, unknown>) { return _post("/api/admin/license/deployments", data) }
export async function startDeployment(id: number) { return _post(`/api/admin/license/deployments/${id}/start`) }
export async function advanceDeployment(id: number, percent?: number) { return _post(`/api/admin/license/deployments/${id}/advance`, { percent }) }
export async function pauseDeployment(id: number) { return _post(`/api/admin/license/deployments/${id}/pause`) }
export async function abortDeployment(id: number) { return _post(`/api/admin/license/deployments/${id}/abort`) }
export async function getServers(): Promise<ServerInfo[]> { return _get("/api/admin/license/servers") }
export async function getReleases(): Promise<ReleaseInfo[]> { return _get("/api/admin/license/releases") }
export async function forceUpdateServer(activationId: number, depId: number) { return _post(`/api/admin/license/servers/${activationId}/force-update?dep_id=${depId}`) }

// ── Identifier history ──

export async function getIdentifierHistory(campaignId: string) {
  const r = await fetch(`${Z}/api/identifier-history/${encodeURIComponent(campaignId)}`)
  return r.ok ? (await r.json()).values ?? [] : []
}

// ── Backup ──

export interface BackupSettings {
  local: { enabled: boolean; time: string; retention_days: number }
  dev_server: { enabled: boolean; interval_days: number; retention_days: number }
  custom_remote: { enabled: boolean; host: string; port: number; username: string; password: string; remote_path: string; interval_days: number; time: string; retention_days: number }
  _state?: { last_local_backup?: string; last_dev_upload?: string; last_custom_upload?: string }
}
export interface BackupFile { filename: string; size: number; created_at: string }

export async function getBackupSettings(): Promise<BackupSettings> { return _get("/api/backup/settings") }
export async function saveBackupSettings(data: Partial<BackupSettings>) { return _post("/api/backup/settings", data) }
export async function getBackupList(): Promise<BackupFile[]> { return _get("/api/backup/list") }
export async function createBackup() { return _post("/api/backup/create") }
export async function restoreBackup(filename: string) { return _post("/api/backup/restore", { filename }) }
export async function deleteBackup(filename: string) { await _void_delete(`/api/backup/${encodeURIComponent(filename)}`) }
export function downloadBackupUrl(filename: string) { return `${Z}/api/backup/download/${encodeURIComponent(filename)}` }
export async function testBackupRemote(cfg: Record<string, unknown>) { return _post("/api/backup/test-remote", cfg) }
export async function uploadBackupDev(data?: Record<string, unknown>) { return _post("/api/backup/upload-dev", data || {}) }
export async function uploadBackupCustom(data?: Record<string, unknown>) { return _post("/api/backup/upload-custom", data || {}) }

// ── Config manager ──

export async function exportAllConfigs() {
  const r = await fetch(`${Z}/api/booster/configs/export`)
  const blob = await r.blob()
  const m = (r.headers.get('content-disposition') || '').match(/filename="?([^"]+)"?/)
  const name = m ? m[1] : 'creepbrowser_configs.json'
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a'); a.href = url; a.download = name; a.click(); URL.revokeObjectURL(url)
}
export async function importAllConfigs(data: unknown) { return _post("/api/booster/configs/import", data) }
export async function importBasConfigs(file: File): Promise<{ ok: boolean; imported: number; created: Array<{ id: string; name: string; archived: boolean; mapped: number; ignored: number; warnings: string[] }>; error?: string }> {
  const fd = new FormData()
  fd.append("file", file)
  const r = await fetch(`${Z}/api/booster/configs/import-bas`, { method: "POST", body: fd })
  return r.json()
}

// ── Identifier analytics ──

export type IdentifierPeriod = 'today' | 'yesterday' | '7d'
export interface IdentifierSiteEntry {
  site: string
  count: number
  last_ts: number
  campaigns: Array<{ id: string; name: string; count: number }>
}
export interface IdentifierCampaignEntry {
  id: string
  name: string
  ok: number
  fail: number
  last_ts: number
  running?: boolean
}
export interface IdentifierItem {
  identifier: string
  identifier_label: string
  runs: number
  ok: number
  fail: number
  success_rate: number | null
  unique_sites: number
  top_sites: IdentifierSiteEntry[]
  campaigns: IdentifierCampaignEntry[]
  running_count: number
  last_ts: number
  // Unified metrics
  used_local: number
  avg_local: number | null
  unique_profiles_local: number
  cloud_used: number | null
  cloud_total: number | null
  cloud_avg: number | null
  // Idea #50: статистика по фильтрации профилей
  total_attempts?: number
  new_profiles?: number
  used_profiles?: number
}
export interface IdentifierGroup {
  mode: string
  label: string
  total_runs: number
  total_ok: number
  total_fail: number
  identifiers: IdentifierItem[]
}
export interface IdentifierStats {
  period: IdentifierPeriod
  since: number
  now: number
  groups: IdentifierGroup[]
}
export async function getIdentifierStats(period: IdentifierPeriod): Promise<IdentifierStats> {
  return _get(`/api/identifiers/stats?period=${period}`)
}

// Idea #86 — история числа профилей в облачных пулах по дням недели.
export interface PoolSnapshotPoint { date: string; total: number; free: number }
export interface PoolHistoryItem {
  mode: string
  identifier: string
  identifier_label: string
  points: PoolSnapshotPoint[]
  latest: number
  min: number
  max: number
  delta: number
}
export interface PoolHistory { days: number; pools: PoolHistoryItem[]; now: number }
export async function getProfilePoolHistory(days = 7): Promise<PoolHistory> {
  return _get(`/api/booster/profile-pool-history?days=${days}`)
}
export function downloadIdentifierCsv(period: IdentifierPeriod) {
  const a = document.createElement('a')
  a.href = `${Z}/api/identifiers/csv?period=${period}`
  a.click()
}
export async function getConfigSnapshots(): Promise<ConfigSnapshot[]> { return _get("/api/booster/configs/snapshots") }
export async function saveConfigSnapshot(name: string) { return _post("/api/booster/configs/snapshots", { name }) }
export async function restoreConfigSnapshot(id: string) { return _post(`/api/booster/configs/snapshots/${id}/restore`) }
export async function deleteConfigSnapshot(id: string) { await _void_delete(`/api/booster/configs/snapshots/${id}`) }
